module.exports = {
  menu: {
    home: "Home",
    product: "Services & Products",
    aboutus: "About Us",
    contactus: "Contact us",
    login: "Partnerships"
  },
  select: {
    title: "Language Setting",
    lang: [
      {
        key: "zh-CN",
        name: "Chinese Simplified"
      },
      {
        key: "zh-TW",
        name: "Chinese Traditional"
      },
      {
        key: "en",
        name: "English"
      },
      {
        key: "ja",
        name: "Japanese"
      },
      {
        key: "ko",
        name: "Korean"
      }
    ]
  },
  brandIntro: {
    title: "Shanghai Fuhui Networks Co., Ltd.",
    slogan: "Slogan: Empowering Sustainable Global Business Growth Through Digital Technology",
    intro: {
      title: "Brand Overview",
      paragraphs: [
        "Link2shops (Shanghai Fuhui Networks Co., Ltd.) focuses on digital growth services for domestic and overseas enterprises. As an AI business growth solution provider driven by measurable outcomes such as sales conversion and membership growth, we deeply integrate cutting-edge large language models with digital marketing, membership benefits, and omnichannel customer acquisition. We deliver end-to-end digital solutions encompassing system development, supply chain collaboration, distribution, and refined operations. Through our proprietary AI sales system, we address core pain points including customer acquisition challenges, low conversion rates, and insufficient workforce efficiency—helping enterprises build closed-loop growth systems for acquisition, activation, conversion, and repurchase, turning technology deployment into tangible revenue growth and operational efficiency.",
        "Backed by deep technical expertise and industry experience, we pioneered AISalesPro, our proprietary AI sales system. Featuring integrated capabilities including intelligent outbound calling (voice), intelligent online customer service, intent recognition, objection handling, lead qualification, and full-cycle sales closing, AISalesPro replaces repetitive manual work, significantly reducing operational costs and improving sales conversion efficiency. We remain committed to our core philosophy: technology serves business outcomes, not technology for its own sake."
      ]
    },
    credentials: {
      title: "Credentials & Technical Assurance",
      content:
        "As a National High-Tech Enterprise and Shanghai Specialized and Sophisticated SME, Link2shops' technology platform and full-service systems have obtained PCI DSS Payment Card Industry Data Security Certification, National Cybersecurity Level 3 Protection Certification, and other authoritative domestic and international security and technical certifications. With rigorous compliance standards, we safeguard data security and business trust, ensuring every intelligent service and every transaction remains secure, stable, and fully traceable."
    },
    background: {
      title: "Brand Background & Global Service Network",
      content:
        "Strategically invested by Fuiou Group and headquartered in Shanghai, Link2shops maintains branch offices in Beijing, Wuhan, Hong Kong, Tokyo, and other locations. Our Global Service Network spans China, Japan, Korea, Singapore, Thailand, and beyond. With years of industry expertise, we have served nearly 300 renowned brands and over 10,000 offline stores across diverse commercial scenarios including dining, retail, entertainment, travel, financial benefits, and lifestyle services—delivering global, multi-scenario, and scalable implementation capabilities."
    },
    ecosystem: {
      title: "Omnichannel Ecosystem Partner Network",
      intro:
        "Deeply connected to top global business ecosystem resources, Link2shops serves as an official service provider for mainstream traffic platforms including WeChat, Alipay, and Meituan, helping enterprises efficiently bridge public and private domain traffic. Our core ecosystem partners include:",
      categories: [
        {
          title: "Financial Institutions",
          partners: ["Visa", "CCB", "ICBC", "BOC", "CMB"]
        },
        {
          title: "Airlines & Telecom Operators",
          partners: ["Spring Airlines", "China Eastern Airlines", "Juneyao Airlines", "China Mobile"]
        },
        {
          title: "Global Travel Platforms",
          partners: ["Booking", "Agoda", "Ctrip", "Meituan", "Douyin"]
        }
      ]
    },
    aiStrategy: {
      title: "AI Strategic Vision & Long-Term Value",
      content:
        "Artificial intelligence is our core strategic focus. We continue to advance commercial large model applications, intelligent marketing, and enterprise digital efficiency, continuously expanding our AI product portfolio. Going forward, we will launch a series of AI products and solutions—including AI intelligent order tracking, omnichannel intelligent operations, team efficiency management, and data-driven growth analytics—covering the full business cycle from intelligent customer acquisition and conversion to backend efficiency management. Through end-to-end AI empowerment, we help global business partners achieve cost reduction, revenue growth, and sustainable long-term development."
    }
  },
  products: {
    servers: [
      {
        title: "Distribution Service",
        subTitle: "One-stop integrated solution for merchants",
        desc:
          "Link2shops offers a one-stop merchant integrated solution for overseas’ merchants to increase their sales revenue and brand awareness in China. We help merchants distributing their products or services though over 40 well-known travel and specialized channels in China, such as  banks, airlines, OTAs(Online Travel Agencies), etc.We also provide multiple services to facilitate merchants including online booking, mobile payment, customer service, marketing promotion etc. "
      },
      {
        title: "Marketing Service",
        subTitle: "Link merchants to China’s high-end Market.",
        desc:
          "Link2shops provides overseas benefits for VIPs through Chinese banks, airlines,and  large employers.We customize marketing activities for merchants according to their target market and product features. We can also promote merchants through well-known travel and specialized channels, thereby increasing merchants' brand awareness."
      },
      {
        title: "Retail Business Management System",
        subTitle: "Provide Systems&Software for  retail businesses.",
        desc:
          "Link2shops is a retail IT systems provider. We provide E-voucher Distribution&Redemption System, Reservation System, Comprehensive PaymentsSystem supporting Alipay,WeChat,, Apple pay acquiring, etc."
      }
    ]
  },
  company: {
    title: "Select Partners",
    name: "Shanghai Fuhui Networks Co., Ltd.",
    website: "Website",
    customer: "Customer Service",
    business: "Partnerships",
    fax: "Fax",
    email: "Email",
    address: "Address",
    addressDesc:
      "2/F, Building 6, No.351 Jinzang Rd, Pudong District, Shanghai",
    companyType1: "Financial Institutions",
    companyType2: "Merchants"
  },
  contact: {
    menu1: "Contact us",
    menu2: "Partnerships"
  },
  about: {
    desc1:
      "Link2shops is a one stop retail solution, offering services of distribution, reservation, promotion and payment for domestic and overseas merchants.",
    desc2:
      "We are one of the 9 subsidiaries of a well-known finance group Shanghai Fuiou Group, who processed 800 billion RMB (US$115 billion) transactions, with chartered payment licenses issued by People's Bank of China and State Administration of Foreign Exchange. We also set up subsidiaries, branches, offices in Shanghai, Beijing, Hong Kong , Tokyo."
  }
};



// WEBPACK FOOTER //
// ./src/assets/lang/en.js